import './styles.css';
import PageTitle from '../../../components/Accessibility/PageTitle';
import DefaultButton from '../../../components/Accessibility/DefaultButton';
import DefaultText from '../../../components/Accessibility/DefaultText';
import VoltarButton from '../../../components/Accessibility/VoltarButton';
import { useNavigate } from 'react-router-dom';
import { getBoasVindasAgendamento, getPermissoesSaudeEmocional } from '../../../services/SaudeBemEstar/SaudeEmocionalService';
import { useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import ModalFeedBack from '../../../components/ModalFeedBack';

const Agendamentos: React.FC = () => {

  const [loading, setLoading] = useState<boolean>(true);
  const [textos, setTextos] = useState<string[]>([]);
  const [imagens, setImagens] = useState<string[]>([]);
  const [showModalFeedback, setShowModalFeedback] = useState<{ message: string, open: boolean }>({
    message: '',
    open: false
  })

  const navigate = useNavigate();
  useEffect(() => {
    setLoading(true);
    getBoasVindasAgendamento()
      .then(response => {
        setTextos(response.textos)
        setImagens(response.imagens)
      })
      .finally(() => {
        setLoading(false);
      })
  }, [])

  const handleGetPermissaoAgendamento = () => {
    getPermissoesSaudeEmocional().catch((error) => setShowModalFeedback({
      open: true,
      message: error?.mensagem || 'É necessário realizar outra avaliação antes do agendamento.'
    }))
  };

  useEffect(() => {
    handleGetPermissaoAgendamento()
  }, [])

  const handleBack = () => {
    navigate('/saudeBemEstar/unimedAcolhe/inicio')
  }

  return (
    <div className='page-container'>
      <PageTitle text="Agendamentos" />

      {
        loading
          ?
          <div className="width-100-pc flex-row justify-center">
            <CircularProgress />
          </div>
          :
          <div className="max-width-660 flex-col gap-20">
            {
              imagens.map((img, i) => (
                <img className="width-100-pc" key={i} src={img.replace("data:image/svg;base64,", "data:image/svg+xml;base64,")} alt="agendamento" />
              ))
            }
            {
              textos.map((t, i) => (
                <DefaultText key={i} text={t} />
              ))
            }
          </div>
      }

      <div className="flex-mobile gap-10 width-100-pc">
        <DefaultButton text="Realizar Agendamento" onClick={() => { navigate('/saudeBemEstar/unimedAcolhe/agendamentos/agendar') }} />
        <DefaultButton variant='outlined' text="Mais detalhes" onClick={() => { navigate('/saudeBemEstar/unimedAcolhe/agendamentos/detalhes') }} />
      </div>

      <VoltarButton onClick={handleBack} />
      <ModalFeedBack
        icon='warning'
        showModal={showModalFeedback.open}
        textButton='Ok'
        showButtonModal={true}
        title='Atenção'
        subTitle={showModalFeedback.message}
        handleButtonModal={handleBack}
        handleShowModal={handleBack}
        classNameModal='modal-custom-feedback'
      />
    </div>
  )
}

export default Agendamentos;